<template>
  <div class="Others25Charts">
    <div
      class="o_25_row"
      :style="{
        marginTop: `${$w_Ratio(12 + getShowfontSizeBase(), $store)}px`,
      }"
    >
      <div class="o_25_item">
        <img
          class="o_25_item_icon"
          :style="{
            width: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
            height: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
          }"
          src="@/assets/img/Others25Charts/001.png"
        />
        <div class="o_25_item_info">
          <span
            class="o_25_item_value"
            :style="{
              fontSize: `${$w_Ratio(14 + getShowfontSizeBase(), $store)}px`,
            }"
            >{{ getShowValue(0, 'y', 0) }}</span
          >
          <span
            class="o_25_item_label"
            :style="{
              fontSize: `${$w_Ratio(12 + getShowfontSizeBase(), $store)}px`,
            }"
            >{{ getShowValue(0, 'x', '总数') }}</span
          >
        </div>
      </div>

      <div class="o_25_item">
        <img
          class="o_25_item_icon"
          :style="{
            width: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
            height: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
          }"
          src="@/assets/img/Others25Charts/002.png"
        />
        <div class="o_25_item_info">
          <span
            class="o_25_item_value"
            :style="{
              fontSize: `${$w_Ratio(14 + getShowfontSizeBase(), $store)}px`,
            }"
            >{{ getShowValue(1, 'y', 0) }}</span
          >
          <span
            class="o_25_item_label"
            :style="{
              fontSize: `${$w_Ratio(12 + getShowfontSizeBase(), $store)}px`,
            }"
            >{{ getShowValue(1, 'x', '总数') }}</span
          >
        </div>
      </div>
    </div>

    <div
      class="o_25_row"
      :style="{
        marginTop: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px`,
      }"
    >
      <div class="o_25_item">
        <img
          class="o_25_item_icon"
          :style="{
            width: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
            height: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
          }"
          src="@/assets/img/Others25Charts/003.png"
        />
        <div class="o_25_item_info">
          <span
            class="o_25_item_value"
            :style="{
              fontSize: `${$w_Ratio(14 + getShowfontSizeBase(), $store)}px`,
            }"
            >{{ getShowValue(2, 'y', 0) }}</span
          >
          <span
            class="o_25_item_label"
            :style="{
              fontSize: `${$w_Ratio(12 + getShowfontSizeBase(), $store)}px`,
            }"
            >{{ getShowValue(2, 'x', '总数') }}</span
          >
        </div>
      </div>

      <div class="o_25_item">
        <img
          class="o_25_item_icon"
          :style="{
            width: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
            height: `${$w_Ratio(70 + getShowfontSizeBase(), $store)}px`,
          }"
          src="@/assets/img/Others25Charts/004.png"
        />
        <div class="o_25_item_info">
          <span
            class="o_25_item_value"
            :style="{
              fontSize: `${$w_Ratio(14 + getShowfontSizeBase(), $store)}px`,
            }"
            >{{ getShowValue(3, 'y', 0) }}</span
          >
          <span
            class="o_25_item_label"
            :style="{
              fontSize: `${$w_Ratio(12 + getShowfontSizeBase(), $store)}px`,
            }"
            >{{ getShowValue(3, 'x', '总数') }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/common/request';
export default {
  name: 'Others25Charts',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
    ComboBoxCharts: Object,
  },
  data() {
    return {
      debounce_subscribeConfigurationChange: null, // 订阅Configuration变化的防抖函数
      apiIntervalTaskID: null, // api任务的定时器ID
      staticIntervalTaskID: null, // 静态任务的定时器ID

      fontStyle: {},
      dataSet: {
        seriesList: [],
        source: [],
      },
    };
  },
  created() {
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.startApiIntervalTask();
    this.startStaticIntervalTask();
  },
  methods: {
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    getShowValue(ind, key, defVal) {
      return this.dataSet.source[ind] ? this.dataSet.source[ind][key] || defVal : defVal;
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearTimeout(this.apiIntervalTaskID);
      clearTimeout(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },

    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 清除之前的 interval 任务（如果有的话）
      clearTimeout(this.apiIntervalTaskID);

      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;

      if (ChartsData?.currenEntry !== 'apiData') return;

      this.getApiDataResByFilterAndResponseQuery()
        .then(this.setEchartsOptions)
        .catch(err =>
          console.log('startApiIntervalTask-getApiDataResByFilterAndResponseQuery failed:>>>>', err),
        )
        .finally(() => {
          if (ChartsData?.apiData?.isUseInterval) {
            console.log('开启 interval 任务，间隔请求');
            this.apiIntervalTaskID = setTimeout(
              () => this.startApiIntervalTask(),
              ChartsData?.apiData?.apiInterval * 1000,
            );
          }
        });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;

      if (ChartsData?.currenEntry !== 'staticData') return;

      if (chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let data = this.$_.cloneDeep(ChartsData.staticData);
        data.source.forEach(item => (item.y = 0));
        this.setEchartsOptions(data);
        setTimeout(() => this.setEchartsOptions(this.$_.cloneDeep(ChartsData.staticData)), 0);

        this.staticIntervalTaskID = setTimeout(
          () => this.startStaticIntervalTask(),
          chartsAnimation?.staticRefreshIntervalTime * 1000,
        );
      } else {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');

        this.getApiDataRes()
          .then(res => {
            // query数据
            let keys = ChartsData.apiData.apiResponseQuery.split('.');
            if (keys.length) {
              console.log('keys:>>>>', keys);
              keys.forEach(key => (res = res[key]));
            }

            let result = null;

            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              result = this.run_script(ChartsData.apiData.apiFilter, res);
            } else {
              result = res;
            }

            resolve(result);
          })
          .catch(reject);
      });
    },
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;

      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');

        let param = {
          method: ChartsData.apiData.apiUrlMethod,
          url: ChartsData.apiData.apiUrl,
          params: {},
        };

        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');
          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          param['headers'] = { userkey: user_key };
        }

        request(param)
          .then(resolve)
          .catch(reject);
      });
    },

    setEchartsOptions(data = null) {
      this.fontStyle = {};
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.fontStyle.value) {
        this.fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      if (!data) return;
      this.dataSet = data;
    },

    /**
     * 运行脚本
     * @param {string} script 脚本
     * @param {*} data 数据
     */
    run_script(script, data) {
      let dataSet = {};
      try {
        eval(script);
      } catch (error) {
        console.error('run_script failed: ', error);
      }
      return dataSet;
    },
  },
  beforeUnmount() {
    clearTimeout(this.apiIntervalTaskID);
    clearTimeout(this.staticIntervalTaskID);
    this.unRegisterDebounceAndThrottle();
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function() {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  Configuration: {
    componentTitle: '文字图标组件2',
    componentName: 'Others25Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others25Charts.png',
    id: '',
    style: {
      width: 418,
      height: 218,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            apiUrlMethod: 'get',
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['总数'],
            source: [
              {
                s: '总数',
                x: '客流监控',
                y: 100,
              },
              {
                s: '总数',
                x: '车流监控',
                y: 10,
              },
              {
                s: '总数',
                x: '智慧厕所',
                y: 200,
              },
              {
                s: '总数',
                x: '慢直播',
                y: 22,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 14,
          xAxisColor: '#fff',
          yAxisSize: 14,
          yAxisColor: '#fff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      textComponentUnits: {
        propertyComponentName: 'MapTextConfiger',
        value: '元',
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
.Others25Charts {
  width: 100%;
  height: 100%;
  .o_25_row {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    /* margin-top: 40px; */
    .o_25_item {
      display: flex;
      align-items: center;
      .o_25_item_icon {
        display: flex;
        /* width: 66px;
        height: 66px; */
      }
      .o_25_item_info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .o_25_item_value {
          color: #85cdff;
          font-size: 30px;
          font-weight: bold;
        }
        .o_25_item_label {
          display: inline-block;
          min-width: 76px;
          color: #ffffff;
          font-size: 16px;
          text-align: center;
          white-space: nowrap;
        }
      }
    }
    &:nth-child(1) {
      margin-top: 0;
    }
  }
}
</style>
